// import React, { useEffect, useState } from 'react';
// import { Routes, Route } from 'react-router-dom';

// //Layouts
// import NonAuthLayout from 'Layouts/NonAuthLayout';
// import VerticalLayout from 'Layouts/index';

// //routes
// import { authProtectedRoutes, publicRoutes } from './allRoutes';
// import AuthProtected from './AuthProtected';
// import { getCheckLogin } from 'services/authService';

// const Index = () => {
//   const [authStatus, setAuthStatus] = useState<boolean | null>(null);
//   const [routesLoaded, setRoutesLoaded] = useState(false);

//   useEffect(() => {
//     const checkAuth = async () => {
//       try {
//         const status = await getCheckLogin();
//         setAuthStatus(status);
//       } catch (error) {
//         console.error('Authentication check failed:', error);
//         setAuthStatus(false);
//       } finally {
//         setRoutesLoaded(true);
//       }
//     };

//     checkAuth();
//   }, []);

//   if (authStatus === null) return null;
//   if (!routesLoaded) return null;
//   return (
//     <React.Fragment>
//       <Routes>
//         <Route>
//           {publicRoutes(authStatus!).map((route: any, idx: any) => (
//             <Route
//               path={route.path}
//               element={<NonAuthLayout>{route.component}</NonAuthLayout>}
//               key={idx}
//             />
//           ))}
//         </Route>

//         <Route>
//           {authProtectedRoutes.map((route: any, idx: any) => (
//             <Route
//               path={route.path}
//               element={
//                 // <AuthProtected>
//                 //   <VerticalLayout>{route.component}</VerticalLayout>
//                 // </AuthProtected>
//                 <AuthProtected authenticated={authStatus!}>
//                   <VerticalLayout>{route.component}</VerticalLayout>
//                 </AuthProtected>
//                 // <AuthProtected>
//                 //   <VerticalLayout>{route.component}</VerticalLayout>
//                 // </AuthProtected>
//               }
//               key={idx}
//             />
//           ))}
//         </Route>
//       </Routes>
//     </React.Fragment>
//   );
// };

// export default Index;

import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Layouts
import NonAuthLayout from 'Layouts/NonAuthLayout';
import VerticalLayout from 'Layouts';

// routes
import { authProtectedRoutes, publicRoutes } from './allRoutes';
import AuthProtected from './AuthProtected';
import { RootState } from 'slices';
import { useSelector } from 'react-redux';

const Index = () => {
  const { authenticated } = useSelector((state: RootState) => state.Login);

  return (
    <React.Fragment>
      <Routes>
        {/* Public routes */}
        <Route>
          {publicRoutes(authenticated).map((route: any, idx: any) => (
            <Route
              key={idx}
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            />
          ))}
        </Route>

        {/* Protected routes */}
        <Route>
          {authProtectedRoutes.map((route: any, idx: any) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <AuthProtected>
                  <VerticalLayout>{route.component}</VerticalLayout>
                </AuthProtected>
              }
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
